import styled from 'styled-components';

import {PriceLabel} from '~/shared/components/PriceLabels';
import {FlexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {Arrow} from '~/shared/components/UserTransactions/components/CustomTable/CellRenderer';

import {ArrowCell, Cell, MiddleCell, StyledTableHead} from './common';
import {GroupParentType} from './utils';

const StyledParentRow = styled(StyledTableHead)`
  background: ${({theme}) => theme.colors.surface};
  color: ${({theme}) => theme.colors.contentDefault};
  cursor: pointer;
  width: 100%;
  padding: 0;
  ${flipOnLTR`
    padding-left: 34px;
  `}
`;

interface IParentHeadRow {
  item: GroupParentType;
  onParentClick: (id: GroupParentType['parentId']) => void;
  isOpen: boolean;
}

const ParentHeadRow = ({item, onParentClick, isOpen}: IParentHeadRow) => {
  return (
    <StyledParentRow as="button" onClick={() => onParentClick(item.parentId)}>
      <FlexCenterVertically>
        <ArrowCell>
          <Arrow $facedown={isOpen} />
        </ArrowCell>
        <Cell>{item.dateLabel}</Cell>
      </FlexCenterVertically>
      <FlexCenterVertically>
        <Cell width={60}>
          <PriceLabel price={item.employeePart} />
        </Cell>
        <MiddleCell width={70}>
          <PriceLabel price={item.employerPart} />
        </MiddleCell>
        <Cell width={70}>
          <PriceLabel bold price={item.dailySum} />
        </Cell>
      </FlexCenterVertically>
    </StyledParentRow>
  );
};

export default ParentHeadRow;
